import Request, { Methods } from '@libraries/request/'

export default class Wallpaper extends Request {
  constructor() {
    super()
  }

  get path() {
    return '/apis/wallpaper'
  }

  get method() {
    return Methods.get
  }

  decode({ data }) {
    return data
  }
  decodeError(error) {
    return { error: error }
  }

}
